import { Formik, Form, Field } from "formik";
import { useState } from "react";
import { Col, Form as BTSForm, Modal, Row } from "react-bootstrap";
import * as yup from "yup";
import GradientButton from "../../../../Core/GradientButton";
import AlertModal from "../../../../Core/AlertModal";
import { useSessionStore } from "../../../../../Stores/SessionStore";

const validationSchema = yup.object({
	NewEmail: yup.string().trim().required("New email is required.").email("Please enter a valid email address."),
}).required();

export default function ChangeEmailModal({ show, onClose }) {
	const store = useSessionStore();
	const [saving, setSaving] = useState(false);
	const [error, setError] = useState(null);
	const [alert, setAlert] = useState(null);

	const customer = store.CustomerDetails?.Customer;
	const currentEmail = customer?.Email ?? "";

	async function handleSubmit(values) {
		if (!customer) return;

		setError(null);
		setSaving(true);
		const result = await store.CustomersService.UpdateProfile({
			Email: values.NewEmail.trim(),
			CellphoneNumber: customer.CellphoneNumber,
			Language: customer.LanguagePreference,
			CommunicationPreference: customer.EmailPreference,
		});
		setSaving(false);

		if (result?.Success) {
			await store.LoadCustomerDetails();
			setAlert({
				show: true,
				success: true,
				title: "Email Updated",
				message: "Your email address has been updated successfully.",
				onClose: () => {
					setAlert(null);
					onClose();
				},
			});
			return;
		}

		setError(result?.Message ?? "There was an error updating your email. Please try again.");
	}

	return (
		<>
			<Modal show={show} onHide={onClose} size="lg">
				<Modal.Header>
					<h3>Change Email</h3>
				</Modal.Header>
				<Modal.Body>
					<Formik initialValues={{ NewEmail: "" }} validationSchema={validationSchema} onSubmit={handleSubmit}>
						{({ errors, touched, isValid, dirty }) => (
							<Form>
								<BTSForm.Group as={Row} className="mb-3">
									<BTSForm.Label column sm={4}>Current Email</BTSForm.Label>
									<Col sm={8}>
										<BTSForm.Control value={currentEmail || "(no email on file)"} readOnly disabled className="bg-light"/>
									</Col>
								</BTSForm.Group>
								<BTSForm.Group as={Row} className="mb-3">
									<BTSForm.Label column sm={4}>New Email</BTSForm.Label>
									<Col sm={8}>
										<Field
											as={BTSForm.Control}
											type="email"
											name="NewEmail"
											placeholder="Enter your new email address"
											isInvalid={touched.NewEmail && errors.NewEmail}
										/>
										<small className="text-danger">{touched.NewEmail && errors.NewEmail}</small>
									</Col>
								</BTSForm.Group>
								{error && <small className="text-danger d-block mb-3">{error}</small>}
								<GradientButton
									title={saving ? "Saving..." : "Save Changes"}
									variant="greenYellow"
									type="submit"
									disabled={saving || !isValid || !dirty}
									loading={saving}
								/>
								<GradientButton title="Cancel" variant="yellowOrange" onClick={onClose} disabled={saving} className="mt-2" />
							</Form>
						)}
					</Formik>
				</Modal.Body>
			</Modal>
			{alert && <AlertModal modal={alert} />}
		</>
	);
}
